import { Carousel, Image } from "react-bootstrap";
import { usePvSection1 } from "./landing-pv-section1.hook";
import { PVBanner, PVBannerMobile } from "src/assets";

export const PvSection1 = () => {
  const { t } = usePvSection1();

  return (
    <Carousel controls={false} indicators={false}>
      <Carousel.Item>
        <Image
          src={PVBanner}
          alt="PVBanner"
          width="100%"
          height="100%"
          className="sliders-image-max-height d-none d-md-block"
        />
        <Image
          src={PVBannerMobile}
          alt="PVBannerMobile"
          width="100%"
          height="100%"
          className="sliders-image-max-height d-block d-md-none"
        />

        <Carousel.Caption>
          <h1 className="section1-dynamic-size-title white-space-pre">
            {t("landing_pv.section1.title")}
          </h1>
          <div className="mt-3 section1-dynamic-size-subtitle mb-4">
            {t("landing_pv.section1.subtitle")}
          </div>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};
